export const INDUSTRY_DATA = [
  {
    Industry: 'Manufacturing',
    Role: 'Chief Operating Officer',
    ConflictingPriorities: 'INNOVATION vs STABILITY',
    ConflictImplications: 'Every technology change risks production disruption but failing to innovate risks market position.',
    ParadigmShifts: {
      'PRODUCTION PLANNING': {
        from: 'Scheduled Production Runs',
        to: 'Autonomous Production',
      },
      'QUALITY CONTROL': {
        from: 'Statistical Process Control',
        to: 'Intelligent Quality Assurance',
      },
      'PRODUCT DEVELOPMENT': {
        from: 'Sequential Design Process',
        to: 'Generative Manufacturing Design',
      },
    },
    BusinessChallenges: [
      'New product launch takes 9 months vs. industry standard of 3 months',
      'Technical debt increases testing cycles by 40%',
      'Manual integration processes delay feature releases by 6+ weeks',
      'Competitors releasing new features bi-weekly vs. our quarterly cycle',
      'Market share erosion of 2% per quarter due to slower innovation',
    ],
    BusinessValue: [
      '+$8.5M with AI-powered product customization ($425 incremental x 20k customers)',
      '+$3.8M by 42% service contract win rate increase using GenAI-enhanced proposal writing',
      '+$1.2M engineering design cost savings with accelerated generative design',
      '+$2.1M annual savings in quality control through AI visual inspection',
    ],
    DecisionCriteria: [
      'Purpose-built industrial AI services',
      'Integration with IoT and edge computing',
      'Support for real-time processing requirements',
      'Digital twin and simulation capabilities',
      'Manufacturing-specific model training',
    ],
    ConflictingPriorities2: 'EFFICIENCY vs FLEXIBILITY',
    ConflictImplications2: 'Highly efficient processes are often less adaptable to market changes.',
  },
  {
    Industry: 'Healthcare',
    Role: 'VP R&D',
    ConflictingPriorities: 'DIAGNOSTICS SPEED vs ACCURACY',
    ConflictImplications:
      'Faster diagnostics risks false results. Prioritizing accuracy can delay treatment and reduce timely clinical decisions.',
    ParadigmShifts: {
      DIAGNOSTICS: {
        from: 'Clinician Interpretation',
        to: 'Precise Detection',
      },
      TREATMENT: {
        from: 'Population-based Treatments',
        to: 'Tailored Therapies',
      },
      'PATIENT CARE': {
        from: 'Hospital-centric care',
        to: 'At-home testing and monitoring',
      },
    },
    BusinessChallenges: [
      'Integrating AI tools with legacy laboratory systems',
      'Ensuring regulatory compliance across global markets',
      'Managing supply chain disruptions for lab reagents',
    ],
    BusinessValue: [
      '30% reduction in diagnostic processing and labor costs with AI-Legacy integration',
      '$10.3M annual savings from faster global approvals and reduced rework',
      '15-25% lower material costs through predictive inventory and vendor efficiency',
    ],
    DecisionCriteria: [
      'Deep HIPAA-eligible AI service catalogue',
      'Proven "compliance as code" tool ecosystem',
      'Global region and availability coverage',
      'Partner and life-sciences ecosystem integration',
    ],
    ConflictingPriorities2: 'INNOVATION vs STABILITY',
    ConflictImplications2: 'Every technology change risks production disruption but failing to innovate risks market position.',
  },
  {
    Industry: 'Government',
    Role: 'Chief Information Officer',
    ConflictingPriorities: 'INNOVATION vs SECURITY',
    ConflictImplications: 'Driving modernization risks exposing critical systems to cyber threats and compliance violations.',
    ParadigmShifts: {
      INFRASTRUCTURE: {
        from: 'On-premise data centers',
        to: 'Cloud-based architectures',
      },
      'POLICY MAKING': {
        from: 'Siloed decision-making',
        to: 'Integrated public data transparency',
      },
      'CITIZEN SERVICES': {
        from: 'Paper-based or in-person processes',
        to: 'Secure digital portals and mobile access',
      },
    },
    BusinessChallenges: [
      'Integrating legacy systems with modern cloud platforms',
      'Ensuring cybersecurity across decentralized agency networks',
      'Managing data privacy under evolving regulations',
    ],
    BusinessValue: [
      '$15-25 million annual savings through consolidation and automation',
      '40-60% reduction in breach remediation costs, avoiding incidents that average $4-8 million each',
      '20-30% compliance cost savings via automated data governance and consent management tools',
    ],
    DecisionCriteria: [
      'Proven FedRAMP and StateRAMP compliance framework',
      'Extensive U.S. government cloud region coverage',
      'Deep AI integration with existing data lakes',
      'Robust cost optimization and transparency tools',
    ],
    ConflictingPriorities2: 'COST vs PERFORMANCE',
    ConflictImplications2: 'Budget constraints can limit infrastructure capacity, reducing reliability and citizen service quality.',
  },
  {
    Industry: 'Financial Services',
    Role: 'Chief Information Security Officer',
    ConflictingPriorities: 'SECURITY vs AGILITY',
    ConflictImplications: 'Tight controls can slow innovation and delay time-to-market for new financial products.',
    ParadigmShifts: {
      TRADING: {
        from: 'Static algorithms',
        to: 'AI driven quantitative models',
      },
      INFRASTRUCTURE: {
        from: 'On-premise data centers',
        to: 'Cloud-based architectures',
      },
      'CYBER RESILIENCE': {
        from: 'Manual oversight',
        to: 'Zero-trust architectures',
      },
    },
    BusinessChallenges: [
      'Balancing zero-trust security with user productivity',
      'Managing third-party vendor and API risks',
      'Meeting global data privacy compliance requirements',
      'Detecting insider threats across hybrid environments',
    ],
    BusinessValue: [
      '$2-4 million annual savings from fewer access issues and downtime',
      '$10 million reduction in breach related losses including remediation and legal costs',
      '$6 million annual risk avoidance from prevented data leaks and fines',
    ],
    DecisionCriteria: [
      'Built-in financial-sector security and compliance framework',
      'Superior encryption key management and control',
      'Deep integration with enterprise identity systems',
    ],
    ConflictingPriorities2: 'RISK vs EXPERIENCE',
    ConflictImplications2: 'Strong authentication and monitoring may frustrate employees and clients, impacting satisfaction and adoption.',
  },
  {
    Industry: 'Software & Internet (Europe)',
    Role: 'Chief Data Protection Officer',
    ConflictingPriorities: 'PRIVACY vs PERSONALIZATION',
    ConflictImplications: 'Stricter data limits reduce user profiling accuracy, weakening engagement and ad revenue potential.',
    ParadigmShifts: {
      'DATA GOVERNANCE': {
        from: 'Data harvesting',
        to: 'User consent',
      },
      TRANSPARENCY: {
        from: 'Opaque algorithms',
        to: 'Explainable recommendations',
      },
      INTEROPERABILITY: {
        from: 'Single platform dominance',
        to: 'Distributed systems',
      },
    },
    BusinessChallenges: [
      'Ensuring GDPR compliance across multiple jurisdictions',
      'Managing cross-border data transfer restrictions',
      'Balancing user consent with analytics needs',
      'Implementing privacy-by-design in product development',
    ],
    BusinessValue: [
      '€5-10 million annually through unified compliance frameworks',
      '€3-6 million savings per year from reduced reliance on redundant data centers and intermediaries',
      '€4-8 million annually by reducing rework, breach risk, and regulatory remediation expenses',
    ],
    DecisionCriteria: [
      'GDPR-compliant DPA & SCCs by default',
      'EU-only data residency & sovereignty controls',
      'German-based sovereign cloud operations exclusively',
      'German BSI / C5 attestation support systems',
    ],
    ConflictingPriorities2: 'COMPLIANCE vs INNOVATION',
    ConflictImplications2: 'Rigorous GDPR controls can delay or restrict deployment of new AI-driven features.',
  },
];
